export default function (nodeList) {
  return [].slice.call(nodeList)
}
